import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  regionActions,
  regionSelectors,
} from 'containers/Pages/Region/Region/index';
import {
  closeDetails,
  getCurrentPage,
  openDetails,
  toggleModal,
} from 'reducers/ui';
import { PAGE_URLS } from 'utils/constants';
const RegionDetails = ({ id, cancel, editable, toggleEditMode }) => {
  const regionDetails = useSelector(
    state => regionSelectors.getTransformedRegionDetails(state),
    shallowEqual,
  );
  const pageUrl = useSelector(state => getCurrentPage(state));
  const dispatch = useDispatch();
  const dispatchFetchRegionDetails = useCallback(
    id => dispatch(regionActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchSetRegionID = useCallback(
    id => {
      return dispatch(regionActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const dispatchClearRegionDetails = useCallback(
    () => dispatch(regionActions.setGridRowDetails({})),
    [dispatch],
  );
  const dispatchRemoveRegionOnMapId = useCallback(
    () => dispatch(regionActions.setSelectedRowID(null)),
    [dispatch],
  );
  const dispatchCloseDetails = useCallback(
    url => {
      dispatch(closeDetails(url));
    },
    [dispatch],
  );
  const onEdit = () => {
    toggleEditMode();
    dispatch(toggleModal(PAGE_URLS.REGION.name));
  };
  useEffect(() => {
    if (id) {
      dispatchFetchRegionDetails(id);
      dispatchOpenDetails(pageUrl);
      dispatchSetRegionID(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const cancelDetails = () => {
    cancel();
    dispatchCloseDetails(pageUrl);
    dispatchClearRegionDetails();
    dispatchRemoveRegionOnMapId();
  };
  return (
    <BaseDetails
      header="Region Details"
      editable={editable}
      cancel={cancelDetails}
      details={regionDetails}
      onEdit={onEdit}
    />
  );
};
RegionDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  editable: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};
export default RegionDetails;
